import { AvailableIcons } from '@asn/icon';

import { CUSTOM_ELEMENTS_SCHEMA, Component, ViewEncapsulation, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import '@asn/icon';

/**
 * @ngdoc component
 * @name ApIconLinkComponent
 * @module ApIconLinkModule
 * @description A component a link with an icon
 */
@Component({
    selector: 'ap-icon-link',
    templateUrl: './icon-link.component.html',
    styleUrls: ['./icon-link.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgTemplateOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApIconLinkComponent {
    /**
     * Required - The link
     */
    public readonly link = input.required<string>();

    /**
     * Required - The icon to display
     */
    public readonly iconName = input.required<AvailableIcons>();

    /**
     * The size of the icon. Defaults to `medium`
     * Available sizes: extra-small, small, medium, large, extra-large.
     */
    public readonly iconSize = input('medium');

    /**
     * Open links in a new tab. Defaults to `false`
     */
    public readonly newTab = input(false);
}
